export default __webpack_public_path__ + "static/media/Warranty.f6b9078f.png";